import React,{useState} from 'react';
import {Dialog,DialogContent,DialogActions,Button, IconButton } from '@material-ui/core';
import WhatsappButtonLink from "./WhatsappButtonLink";
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

const WhatsappButtons=({Index,id,phone,status,dinersCount,name})=>
{
    const [openModal, setopenModal] = useState(false);
    const changeStatus=()=>setopenModal(!openModal);

    const BodyLetterS="La próxima mesa que se libere es para ustedes! Por favor confirmanos que la seguís necesitando, caso contrario la liberamos sin problema ;)";
    const BodyLetterPREGUNTA=`En este momento están en el puesto ${Index}, siguen necesitando la mesa? Así se si dejarlos activos en la lista o liberamos el lugar para otro grupo`;
    const BodyLetterX=`${name} lamentablemente no vamos a poder recibirlos hoy, en breve comienza el cierre del local por normas municipales y no tenemos mesas disponibles`;

    const linkList=`https://baumlanus.com.ar/lista/${id}`;
    const linkCancel=`https://baumlanus.com.ar/lista/${id}/cancelar`;
    const whatsappAPI=`https://api.whatsapp.com/send?phone=${phone}&text=`;
    const bodyTextMax4  = `Estás en el puesto ${Index} para mesa de mas de 2 personas.\n Podes chequear la posición en todo momento en: ${linkList} \nSi no necesitas mas la mesa podés cancelar ingresando acá: ${linkCancel}`;
    const bodyTextMax2  = `Estás en el puesto ${Index} para mesa hasta de de 2 personas.\n Podes chequear la posición en todo momento en: ${linkList} \nSi no necesitas mas la mesa podés cancelar ingresando acá: ${linkCancel}`;
    const bodyTextNoInfo= `Los llamamos y no estaban presentes 😔! Por favor volverse a anotar en caso de necesitar la mesa en baumlanus.com.ar/lista 🙌`;

    const TextMax4=whatsappAPI+bodyTextMax4;
    const TextMax2=whatsappAPI+bodyTextMax2;
    const TextNoInfo=whatsappAPI+bodyTextNoInfo;

    let BodyLetterP=undefined;

                 
    if(status==="no-info")
    {   
        BodyLetterP=TextNoInfo;
    }
    else
    {
        dinersCount >2 ? BodyLetterP=TextMax4 : BodyLetterP=TextMax2;
    }

    const Botones=()=>
    {
        return <Dialog open={openModal} onClose={changeStatus}>
            <DialogContent style={{display:"flex"}}>
            <WhatsappButtonLink letter="C" link={whatsappAPI}/>
            <WhatsappButtonLink letter="P" link={whatsappAPI+BodyLetterP}/>
            <WhatsappButtonLink letter="S" link={whatsappAPI+BodyLetterS}/>
            <WhatsappButtonLink letter="?" link={whatsappAPI+BodyLetterPREGUNTA}/>
            <WhatsappButtonLink letter="X" link={whatsappAPI+BodyLetterX}/>
            </DialogContent>
            <DialogActions>
                <Button color="primary" variant="outlined" onClick={changeStatus}>Cancelar</Button>
            </DialogActions>
        </Dialog>
    }
    

    return <>
    <IconButton aria-label="whatsapp" onClick={changeStatus}>
        <MoreHorizIcon onClic/>
    </IconButton>
    <Botones/>
    </>
}

export default WhatsappButtons;